const baseStyle = {
  mb: 'auto',
};

export default { baseStyle };
